<template>
  <div class="list">
    <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
      <el-form-item>
        <el-input
          v-model="listQuery.keyword_search"
          clearable
          style="width: 200px"
          class="name-input"
          clearable
          placeholder="请输入关键词"
        />
      </el-form-item>

      <el-form-item label="状态筛选:" class="mr-select">
        <el-select v-model="listQuery.status" style="width: 200px" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="显示" value="1"></el-option>
          <el-option label="隐藏" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="add">
        <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
        <el-button v-if="hasAdd" type="primary" size="small" icon="el-icon-plus" @click="jumpLink('add')"
          >新建</el-button
        >
      </el-form-item>
    </el-form>

    <el-table v-loading="listLoading" :data="list" border style="width: 100%" align="center" size="mini">
      <el-table-column prop="sort" label="排列序号" align="center" width="100" />
      <el-table-column label="banner" align="center">
        <template slot-scope="scope">
          <viewer v-if="scope.row.banner_img">
            <img :src="imgDomain + scope.row.banner_img" class="viewer-img" />
          </viewer>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="行业解决方案名称" align="center" />
      <el-table-column label="状态" width="120" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.status === 1 ? "显示" : "隐藏" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center" width="160" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="hasHide && scope.row.status == 1"
            type="primary"
            size="mini"
            class="op_buttton"
            @click="showDialog('hide', scope)"
            >隐藏</el-button
          >
          <el-button
            v-if="hasShow && scope.row.status == 2"
            type="primary"
            size="mini"
            class="op_buttton"
            @click="showDialog('show', scope)"
            >显示</el-button
          >
          <el-button v-if="hasEdit" type="primary" size="mini" class="op_buttton" @click="jumpLink('edit', scope)"
            >编辑</el-button
          >
          <el-button v-if="hasDelete" type="danger" size="mini" class="op_buttton" @click="showDialog('delete', scope)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>
  </div>
</template>
<script>
import { getIndustrySolutions, deleteIndustrySolutions, showIndustrySolutionsOption } from "@/api/solution.js";
import Pagination from "@/components/Pagination";
import operations from "../../mixins/operations";
import { imgDomain } from "@/configs/env";
export default {
  components: { Pagination },
  mixins: [operations],
  data() {
    return {
      imgDomain,
      list: [],
      dialogVisible: false,
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
        keyword_search: "",
        status: "",
      },
      listLoading: false,
    };
  },
  computed: {
    hasAdd() {
      return this.operations.includes("新建行业解决方案");
    },
    hasEdit() {
      return this.operations.includes("编辑行业解决方案");
    },
    hasDelete() {
      return this.operations.includes("删除行业解决方案");
    },
    hasShow() {
      return this.operations.includes("显示行业解决方案");
    },
    hasHide() {
      return this.operations.includes("隐藏行业解决方案");
    },
  },
  async mounted() {
    sessionStorage.removeItem("scenceList");
    this.getList();
  },
  methods: {
    async getList(params = this.listQuery) {
      this.listLoading = true;
      const { total, data } = await getIndustrySolutions(params);
      this.listLoading = false;
      this.total = total;
      this.list = data;
    },

    jumpLink(value, scope) {
      if (value == "edit") {
        this.$router.push({
          path: "./add-solution",
          query: {
            id: scope.row.id,
          },
        });
      } else {
        this.$router.push({
          path: "./add-solution",
        });
      }
    },

    showDialog(value, scope) {
      if (value == "delete") {
        this.$confirm(`是否删除该解决方案？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const res = await deleteIndustrySolutions(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "方案删除成功", type: "success" });
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      } else if (value == "show") {
        this.$confirm(`是否显示该解决方案？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "",
        })
          .then(async () => {
            const res = await showIndustrySolutionsOption(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "已显示该解决方案", type: "success" });
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      } else if (value == "hide") {
        this.$confirm(`是否隐藏该解决方案？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "",
        })
          .then(async () => {
            const res = await showIndustrySolutionsOption(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "已隐藏该解决方案", type: "success" });
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  .add {
    float: right;
    margin-bottom: 20px;
  }
  .button_wrap {
    text-align: center;
    margin-top: 30px;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
  .op_buttton {
    margin-bottom: 10px;
  }
  .viewer-img {
    width: 124px;
    height: 80px;
  }
  .mr-select {
    margin-left: 20px;
  }
}
</style>
